module.exports = __webpack_public_path__ + "img/s3Model1.09197145.webp";